import {gql} from '@apollo/client';

import * as ObservationFragments from 'web-app/react/entities/observations/fragments';

export const ObservationsByIds = gql`
    query ObservationsByIds($observationIds: [ObservationId!]!) {
        childDevelopment {
            observations(first: 100, observationIds: $observationIds, ignoreMissing: true) {
                results {
                    ...ObservationData
                }
            }
        }
    }
    ${ObservationFragments.ObservationData}
`;

export const FrameworksForObservations = gql`
    query FrameworksForObservations($ids: [FrameworkId!]) {
        childDevelopment {
            frameworks(ids: $ids) {
                ...Framework
            }
        }
    }
    ${ObservationFragments.Framework}
`;
